<template>
  <div class="file-download-container">
    <div class="file-item" v-for="(item, index) in fileList" :key="index">
      <div class="file-left"></div>
      <div class="file-center">
        {{ item.title }}
      </div>
      <div class="file-right" @click="downloadHandle(item)"></div>
    </div>
  </div>
</template>
<script>

export default {
  name: "fileDownload",
  props: {
    fileList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  methods: {
    downloadHandle(item) {
      let name = ''
      fetch(item.url).then(response => {
        let fileStrArr = response.url.split('/')
        let fileStr = fileStrArr[fileStrArr.length-1]
        name = decodeURIComponent(fileStr)
        return response.blob()
      }).then(blob => {
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.style.display = "none"; // 使其隐藏
        a.href = url;
        a.download = name;
        a.click();

        URL.revokeObjectURL(url);
      });
    },
  }
}
</script>
<style lang="scss" scoped>
.file-download-container{
  margin-top: 5px;

  .file-item{
    width: 360px;
    min-height: 100px;
    background: #FFFFFF;
    padding: 25px 0;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px dashed #E3E3E3;
    
    &:last-child{
      border: 0;
    }

    .file-left{
      flex: 0 0 40px;
      height: 40px;
      background: url(~@/assets/images/common/file-item-icon.png) center top no-repeat;
      background-size: cover;
      margin-right: 16px;
    }
    .file-center{
      flex: 1;
      margin-right: 30px;
      font-size: 16px;
      line-height: 24px;
      color: #333;
    }

    .file-right{
      flex: 0 0 20px;
      height: 20px;
      background: url(~@/assets/images/common/file-download-icon.png) center top no-repeat;
      background-size: cover;
      margin-right: 2px;
      cursor: pointer;
    }
  }
}
</style>